import { internalErrorMessage } from '../error';

export type ConnectionReadyCallback = (port: MessagePort) => void;

export type IPostMessage = (message: string, port?: MessagePort) => void;
export type IOnMessage = (listener: MessageEventListener) => void;

type MessageEventListener = (message: MessageEvent) => void;

export abstract class AbstractHandshake {
  #listeners = new Set<ConnectionReadyCallback>();
  #activePort?: MessagePort;

  protected constructor(
    protected postMessage: IPostMessage,
    protected onMessage: IOnMessage,
  ) {}

  #notifyHandshakeListeners() {
    const port = this.#activePort;

    if (!port) {
      console.warn(
        internalErrorMessage(
          'port is required no notify onHandshake listeners',
        ),
      );
      return;
    }

    this.#listeners.forEach((cb) => cb(port));
  }

  protected setActivePort(port: MessagePort) {
    this.dispose();

    this.#activePort = port;
    this.#notifyHandshakeListeners();
  }

  protected dispose() {
    if (this.#activePort) {
      this.#activePort.close();
      this.#activePort.onmessage = null;
    }
  }

  public onHandshake(callback: ConnectionReadyCallback) {
    this.#listeners.add(callback);

    return () => {
      this.#listeners.delete(callback);
    };
  }
}
